import Script from 'next/script';
import { useConsentHandler } from '@/lib/consent';
import { disableMetaPixel, enableMetaPixel } from '@/lib/analytics/metaPixel/client';
import { META_PIXEL_READY_EVENT } from '@/lib/analytics/metaPixel/constants';
import { useMetaPixelEnabled } from '@/lib/analytics/metaPixel/useMetaPixelEnabled';
import { NEXT_PUBLIC_META_PIXEL_ID } from '@/lib/env';

const MetaPixelScript = () => {
  useConsentHandler('metaPixel', ({ allowed }) => {
    if (allowed) {
      enableMetaPixel();
      return;
    }

    disableMetaPixel();
  });

  const metaPixelEnabled = useMetaPixelEnabled();
  if (!metaPixelEnabled) {
    return null;
  }

  return (
    <Script id="meta-pixel" strategy="lazyOnload">
      {`
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');

        fbq('consent', 'grant');
        fbq('set', 'autoConfig', false, '${NEXT_PUBLIC_META_PIXEL_ID}');
        fbq('init', '${NEXT_PUBLIC_META_PIXEL_ID}');
        window.dispatchEvent(new Event('${META_PIXEL_READY_EVENT}'));
      `}
    </Script>
  );
};

export default MetaPixelScript;
